import React, { useState, useEffect, useRef } from 'react';

const SlideshowSelector = ({ items, selectedId, onSelect, label, cardColors: customCardColors }) => {
    const selectedItem = items.find(item => item.id === selectedId);
    const [currentIndex, setCurrentIndex] = useState(0);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const selectedIndex = items.findIndex(item => item.id === selectedId);
        if (selectedIndex !== -1) {
            setCurrentIndex(selectedIndex);
        }
    }, [selectedId, items]);

    const resetTimeout = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }

    useEffect(() => {
        resetTimeout();
        timeoutRef.current = setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
        }, 3000);

        return () => {
            resetTimeout();
        };
    }, [currentIndex, items.length]);

        const handleSelect = (item, index) => {
        // Always call onSelect to allow handlers to process disabled items (like showing toast)
        onSelect(item.id);
        
        // Only update current index if item is not disabled
        if (!item.disabled) {
            setCurrentIndex(index);
        }
    };



    return (
                        <div className="w-full max-w-md mx-auto">
                        <label className="block text-sm font-medium text-gray-700 mb-3 text-center">
                {label}: <span className="font-bold text-indigo-600">{selectedItem?.name}</span>
            </label>
            <div className="overflow-hidden relative p-2">
                <div
                    className="flex transition-transform duration-500 ease-in-out"
                    style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                >
                    {items.map((item, index) => {
                        const isSelected = selectedId === item.id;
                        const cardColors = customCardColors || [
                            'bg-sky-100/30',
                            'bg-rose-100/30',
                            'bg-amber-100/30',
                            'bg-teal-100/30',
                            'bg-violet-100/30',
                            'bg-lime-100/30'
                        ];
                        const colorClass = cardColors[index % cardColors.length];
                        
                                                                        const baseCardClasses = "relative flex-shrink-0 w-full p-4 rounded-xl flex flex-col justify-center items-center text-center cursor-pointer transition-all duration-300 border backdrop-blur-3xl shadow-lg bg-gradient-to-br from-white/10 to-transparent";
                                                const activeClasses = "ring-2 ring-blue-500 border-blue-500 shadow-xl z-10";
                        const inactiveClasses = `border-white/30 hover:border-white/50 hover:shadow-xl`;
                        const disabledClasses = "bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed";

                        let finalClasses = `${baseCardClasses} `;
                        if (item.disabled) {
                            finalClasses += disabledClasses;
                        } else {
                            finalClasses += `${colorClass} ${isSelected ? activeClasses : inactiveClasses}`;
                        }

                        return (
                            <div
                                key={item.id}
                                className={finalClasses}
                                onClick={() => handleSelect(item, index)}
                            >
                                {isSelected && !item.disabled && (
                                    <div className="absolute top-2 right-2 w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center text-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                )}
                                                                <div className="text-2xl mb-1">{item.icon}</div>
                                                                <div className="font-bold text-sm text-gray-900">{item.name}</div>
                                <p className="text-xs mt-1 text-gray-500">
                                    {item.description}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="flex justify-center space-x-2 pt-4">
                {items.map((_, idx) => (
                    <button
                        key={idx}
                        onClick={() => {
                            setCurrentIndex(idx);
                            resetTimeout();
                        }}
                        className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${currentIndex === idx ? 'bg-indigo-600 scale-125' : 'bg-gray-300 hover:bg-gray-400'}`}
                        aria-label={`Go to slide ${idx + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default SlideshowSelector;
